/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum HorizontalAlignment {
  Start = 'Start',
  End = 'End'
}
